import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const idiomaticExpressionsQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.IDIOMATIC_EXPRESSIONS,
        questionText: "¿Qué significa la expresión 'estar en las nubes'?",
        options: ["Estar distraído", "Estar en un lugar alto", "Estar feliz", "Estar confundido"],
        correctAnswerIndex: 0,
        explanation: "La expresión 'estar en las nubes' significa estar distraído, pensar en algo que no tiene relación con lo que está pasando alrededor."
    },
    {
        category: QuizCategory.IDIOMATIC_EXPRESSIONS,
        questionText: "Selecciona la opción que completa correctamente la expresión: 'No hay mal que por bien no ___.",
        options: ["venga", "viene", "vendrá", "vino"],
        correctAnswerIndex: 0,
        explanation: "La expresión completa es 'No hay mal que por bien no venga', que significa que de algo malo siempre puede surgir algo bueno."
    },
    {
        category: QuizCategory.IDIOMATIC_EXPRESSIONS,
        questionText: "¿Qué significa la expresión 'más vale tarde que nunca'?",
        options: ["Es mejor hacer algo rápidamente", "Es mejor no hacer nada que hacerlo tarde", "Es mejor llegar tarde que no llegar", "Es mejor no hacer nada que equivocarse"],
        correctAnswerIndex: 2,
        explanation: "La expresión 'más vale tarde que nunca' significa que es mejor hacer algo tarde que no hacerlo en absoluto."
    },
    {
        category: QuizCategory.IDIOMATIC_EXPRESSIONS,
        questionText: "¿Qué significa la expresión 'dar en el clavo'?",
        options: ["Equivocarse", "Acertar en algo", "Trabajar muy duro", "No tener éxito"],
        correctAnswerIndex: 1,
        explanation: "'Dar en el clavo' significa acertar en algo, encontrar la solución correcta o dar con lo que se busca."
    },
    {
        category: QuizCategory.IDIOMATIC_EXPRESSIONS,
        questionText: "Completa la expresión: 'Estar como una cabra' significa...",
        options: ["Estar muy cansado", "Estar muy contento", "Estar triste", "Estar loco o actuar de forma rara"],
        correctAnswerIndex: 3,
        explanation: "'Estar como una cabra' significa estar loco o actuar de forma extraña, fuera de lo común."
    },
    {
        category: QuizCategory.IDIOMATIC_EXPRESSIONS,
        questionText: "¿Qué significa la expresión 'tirar la toalla'?",
        options: ["Descansar después de un trabajo", "Rendirse o dejar de luchar por algo", "Tomar una decisión importante", "Aceptar algo como cierto"],
        correctAnswerIndex: 1,
        explanation: "'Tirar la toalla' significa rendirse o dejar de luchar por algo, es una expresión que viene del boxeo, donde se tiraba la toalla para indicar la rendición."
    },
    {
        category: QuizCategory.IDIOMATIC_EXPRESSIONS,
        questionText: "Selecciona la opción correcta: 'Estar entre la espada y la pared' significa...",
        options: ["Estar en una situación cómoda", "Estar en una situación sin salida, con dos opciones difíciles", "Estar seguro de lo que se quiere", "Estar esperando una respuesta"],
        correctAnswerIndex: 1,
        explanation: "'Estar entre la espada y la pared' significa estar en una situación difícil, donde se deben tomar decisiones difíciles y no hay salida fácil."
    },
    {
        category: QuizCategory.IDIOMATIC_EXPRESSIONS,
        questionText: "¿Qué significa la expresión 'irse por las ramas'?",
        options: ["Hablar demasiado", "Hablar sin llegar al punto, dar muchas explicaciones innecesarias", "Hablar sobre algo sin importancia", "Hablar de algo que no tiene que ver con el tema"],
        correctAnswerIndex: 1,
        explanation: "'Irse por las ramas' significa hablar sin llegar al punto, dar muchas explicaciones innecesarias sin centrarse en el tema principal."
    },
    {
        category: QuizCategory.IDIOMATIC_EXPRESSIONS,
        questionText: "¿Qué significa la expresión 'costar un ojo de la cara'?",
        options: ["Ser muy barato", "Ser muy costoso", "Ser un regalo", "Ser inesperado"],
        correctAnswerIndex: 1,
        explanation: "'Costar un ojo de la cara' significa ser muy costoso, una expresión que indica que algo es muy caro."
    },
    {
        category: QuizCategory.IDIOMATIC_EXPRESSIONS,
        questionText: "¿Qué significa la expresión 'no tener pelos en la lengua'?",
        options: ["Hablar muy claro y sin rodeos", "Hablar muy rápido", "Hablar mucho sin decir nada", "Hablar de forma educada"],
        correctAnswerIndex: 0,
        explanation: "'No tener pelos en la lengua' significa hablar de manera directa, clara y sin rodeos, expresar lo que se piensa sin temor."
    }
];

export default idiomaticExpressionsQuestions;